<div style="padding: 30px;">
  <!-- Header -->
  <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid var(--green-800);margin-bottom: 10px;">
    <h2 style="font-family: ABC Arizona Flare; font-size: 30px; font-weight: 400; color: var(--green-700);">Create New Invoice</h2>
    <div style="display: flex; gap: 20px; align-items: center; margin-bottom: 30px;">
      <span style="color: var(--green-800); cursor: pointer; text-decoration: underline; text-underline-offset: 4px; font-size: 14px; margin-top: 10px;" (click)="handleInvoiceSettingsClicked()">Invoice Settings</span>
      <button class="btn-soft-secondary" style="height: 34px; padding: 0px; margin-top: 10px;" (click)="handleManageInvoicesClicked()">View & Manage Invoices</button>
    </div>
  </div>

  <!-- Content -->
   <div style="margin-top: 10px;">
     <!--Sub Header-->
     <div style="display: flex; justify-content: space-between; align-items: center;">
        <h2 style="font-family: ABC Arizona Flare; font-size: 25px; font-weight: 350; color: var(--green-800);">Invoice #{{invoice.number}}</h2>
        <div [hidden]="viewInvoiceMode" style="display: flex; gap: 20px; align-items: center; margin-bottom: 30px;">
          <span style="color: red; cursor: pointer; text-decoration: underline; text-underline-offset: 4px; font-size: 14px; margin-top: 10px;" (click)="handleDiscardClicked()">Discard</span>
          <button class="btn-secondary" style="height: 40px; margin-top: 10px;" (click)="handleSaveAsDraftClicked()">Save as Draft</button>
          <button class="btn-core" style="height: 40px; margin-top: 10px;" [disabled]="dueByDate === null" (click)="handlePreviewAndSendClicked()">Preview & Send</button>
        </div>
        <div [hidden]="!viewInvoiceMode || invoice.status == 'sent' || invoice.status == 'paid'" style="display: flex; gap: 20px; align-items: center; margin-bottom: 30px;">
          <button class="btn-core" style="height: 40px; margin-top: 10px;" (click)="handleEditInvoiceClicked()">Edit Invoice</button>
        </div>
      </div>
      <!--Content-->
      <div style="display: flex; flex-direction: row; gap: 20px;">
        <!--Left Side-->
        <div style="width: 75%;">
          <div class="cpo-section-container">
            <h2 class="cpo-section-title">01 <span style="font-size: 17px; color: var(--green-700); font-weight: 400;">Customer</span></h2>
            <app-terminal-customer #customerComponent [merchantId]="merchantId" [readonly]="viewInvoiceMode" (onCustomerChange)="handleSelectedCustomerChanged($event)"></app-terminal-customer>
          </div>
          <div class="cpo-section-container">
            <h2 class="cpo-section-title">02 <span style="font-size: 17px; color: var(--green-700); font-weight: 400;">Add Products or Services</span></h2>
            <app-invoice-line-items
              #lineItemsComponent
              (subtotalChange)="handleSubtotalChange($event)"
              [invoiceItems]="invoiceItems"
              [readonly]="viewInvoiceMode"
            ></app-invoice-line-items>
          </div>
          <div class="cpo-section-container" [hidden]="invoiceItems.length === 0">
            <h2 class="cpo-section-title">03 <span style="font-size: 17px; color: var(--green-700); font-weight: 400;">Payment & Due Date</span></h2>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <app-textbox
                [readonly]="false || viewInvoiceMode"
                [label]="'Tax'"
                [minNumericValue]="0"
                [showDefaultValue]="false"
                [type]="inputTextModes.CurrencyUSD"
                (onChanged)="handleTaxChange()"
                [validateOn]="'change'"
                [(ngModel)]="this.tax"
                [style]="'width: 400px;'"
              ></app-textbox>
              <div style="display: flex; gap: 50px; width: 400px; align-items: center; justify-content: flex-end; text-align: center;">
                <span style="font-size: 18px; color: var(--green-800); font-weight: 600;">Total: {{ totalFormatted }}</span>
                <!--Hiding update button for now as all of our values should be auto updating anyways-->
                <!-- <span style="color: var(--green-800); cursor: pointer; text-decoration: underline; text-underline-offset: 4px; font-size: 13px;">update</span> -->
              </div>
            </div>
            <app-multiline
              [label]="'Note to Customer (optional)'"
              [(ngModel)]="this.invoiceNotes"
              [readonly]="viewInvoiceMode"
            ></app-multiline>
            <div class="cpo-section-container" style="border-color: var(--green-400); background-color: var(--green-100); margin-top: 10px;">
              <div style="margin-bottom: 20px; align-items: center; display: flex; gap: 10px;">
                <app-icon type="CalendarClock" [color]="'var(--green-800)'"></app-icon>
                <span style="font-size: 18px; color: var(--green-800); font-weight: 400;">
                  Payment Schedule
                </span>
              </div>
              <!--Hiding payment schedule for now as we don't have a payment schedule option-->
              <!-- <div style="margin-bottom: 20px; width: 70%;">
                <app-radio-group
                  [options]="this.paymentScheduleOptions"
                  [(ngModel)]="this.paymentScheduleMode"
                >
                </app-radio-group>
              </div> -->
              <app-date
                [label]="'Due Date*'"
                [(ngModel)]="this.dueByDate"
                [style]="'width: 300px;'"
                [readonly]="viewInvoiceMode"
              ></app-date>
            </div>
          </div>
        </div>
        <!--Right Side-->
        <div style="width: 25%;">
          <div class="cpo-section-container" style="background-color: var(--green-100); border: none;">
            <h2 class="cpo-section-title" style="font-size: 20px; color: var(--green-800); font-weight: 400;">Invoice Progress</h2>
            <div style="border-bottom: 1px solid var(--green-400); border-top: 1px solid var(--green-400); padding: 10px;">
              <app-radio
              [name]="'customerRadio'"
              [label]="'Customer'"
              [checked]="selectedCustomer !== undefined"
              [readonly]="true"
              [progressTracker]="true"
              ></app-radio>
            </div>
            <div style="border-bottom: 1px solid var(--green-400); padding: 10px;">
              <app-radio
              [name]="'productsRadio'"
              [label]="'Products or Services'"
              [checked]="invoiceItems.length > 0"
              [readonly]="true"
              [progressTracker]="true"
              ></app-radio>
            </div>
            <div style="border-bottom: 1px solid var(--green-400); padding: 10px; margin-bottom: 30px;">
              <app-radio
              [name]="'paymentDueDateRadio'"
              [label]="'Payment & Due Date'"
              [readonly]="true"
              [checked]="dueByDate !== null"
              [progressTracker]="true"
              ></app-radio>
            </div>
          </div>
          <div class="cpo-section-container" style="border: none;">
            <h2 class="cpo-section-title">Reminders & Receipt</h2>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <app-checkbox
                [label]="'Send Email Reminders'"
                [(ngModel)]="sendEmailReminders"
                [readonly]="viewInvoiceMode"
              ></app-checkbox>
              <app-selectbox
                [label]="'Frequency'"
                [options]="emailReminderFrequencyOptions"
                [(ngModel)]="this.emailReminderFrequency"
                [readonly]="viewInvoiceMode || !sendEmailReminders"
              ></app-selectbox>
              <app-textbox
                [label]="'Every X Days'"
                [type]="inputTextModes.Numeric"
                [(ngModel)]="customReminderFrequency"
                [readonly]="viewInvoiceMode || this.emailReminderFrequency != 'custom' || !sendEmailReminders"
              ></app-textbox>
              <app-checkbox
                [label]="'Send customer email receipt'"
                [(ngModel)]="sendCustomerReceipt"
                [readonly]="viewInvoiceMode"
              ></app-checkbox>
              <app-checkbox
                [label]="'Send merchant email receipt'"
                [(ngModel)]="sendMerchantReceipt"
                [readonly]="viewInvoiceMode"
              ></app-checkbox>
              <button [hidden]="invoice.status != 'sent'" class="btn-soft-secondary" style="height: 40px; margin-top: 10px;" (click)="handleSendReminderClicked()">
                Send Invoice Reminder
              </button>
            </div>
          </div>
          <div [hidden]="invoice.status != 'sent'" class="cpo-section-container" style="border: none;">
            <h2 class="cpo-section-title">Pause Invoice Reminders</h2>
            <div style="display: flex; flex-direction: column; gap: 10px;">
              <app-date
                [label]="'Pause Until'"
                [(ngModel)]="this.pauseRemindersUntil"
              ></app-date>
              <button class="btn-core" style="height: 40px; margin-top: 10px;" (click)="handlePauseRemindersClicked()">
                Pause Reminders
              </button>
            </div>
          </div>
        </div>
      </div>
   </div>
</div>